var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseKreis01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-01__Icn/40px/Groesse-Kreis-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-01__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-01__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,16 C22.209139,16 24,17.790861 24,20 C24,22.209139 22.209139,24 20,24 C17.790861,24 16,22.209139 16,20 C16,17.790861 17.790861,16 20,16 Z M20,18 C18.8954305,18 18,18.8954305 18,20 C18,21.1045695 18.8954305,22 20,22 C21.1045695,22 22,21.1045695 22,20 C22,18.8954305 21.1045695,18 20,18 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-01__Oval-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseKreis01);
export default __webpack_public_path__ + "static/media/Groesse-Kreis-01.598dbcbc55b316e686acf7508726dc3e.svg";
export { ForwardRef as ReactComponent };